<template>
  <w-icon-wrapper icon-name='work-greater-than-icon'>
    <g
      id='_60_Größer_Icon'
      data-name='60 Größer_Icon'
      transform='translate(-0.091 0)'
    >
      <g
        id='Gruppe_25444'
        data-name='Gruppe 25444'
      >
        <path
          id='Pfad_55770'
          d='M3.91,20a1,1,0,0,1-.424-1.906L16.545,12,3.486,5.906a1,1,0,0,1,.846-1.812L21.273,12,4.332,19.906A.992.992,0,0,1,3.91,20Z'
          data-name='Pfad 55770'
          fill='currentColor'
        />
      </g>
      <rect
        id='Rechteck_4029'
        data-name='Rechteck 4029'
        fill='none'
        height='24'
        transform='translate(0.091 0)'
        width='24'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconGreaterThan' };
</script>
